module.exports = __webpack_public_path__ + "static/media/deer.8b8e73bb.svg";